import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ContentComponent } from './components/content/content.component';

export const routes: Routes = [
  { path: '', 
    component: ContentComponent
  },
  {
    path: 'about-us',
    loadChildren: () => import('./container/about-us/about-us.module').then(m => m.AboutUsModule) 
  },
  {
    path: 'events',
    loadChildren: () => import('./container/events/events.module').then(m => m.EventsModule) 
  },
  {
      path: 'gallery',
      loadChildren: () => import('./container/gallery/gallery.module').then(m => m.GalleryModule) 
  }
];
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {

}